import store from '../../../store/store';
import { BaseView } from './base-view';
import { SearchResultItem } from '../interfaces/search-result.interface';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { PageTypes } from '../../../common/utils/page-util';

@customElement('mhecomm-product-program-card-view')
export class ProductProgramCardView extends connect(store)(BaseView) {

  @property({ type: Boolean })
  showProductWishList?: boolean;

  private viewName = 'product-program-card-view';

  renderComp() {
    return this.renderSearchResults(this.viewName);
  }

  /**
   * Renders the card view element for a HE product.
   *
   * @param searchResultItem
   */
  override renderHeProduct(searchResultItem: SearchResultItem) {
    return html`
      <mhecomm-he-product-card-display .product=${searchResultItem.product}></mhecomm-he-product-card-display>
    `;
  }

  /**
   * Renders the card view element for a K12 product.
   *
   * @param searchResultItem
   */
  override renderK12Product(searchResultItem: SearchResultItem) {
    return html`
      <mhecomm-k12-product-card-display 
        .product=${searchResultItem.product}
        ?showProductWishList=${this.showProductWishList}
      >
      </mhecomm-k12-product-card-display>
    `;
  }

  /**
   * Renders the list view element for a K12 program.
   *
   * @param searchResultItem
   */
  override renderK12Program(searchResultItem: SearchResultItem) {
    return html`
      <mhecomm-k12-program-card-display .product=${searchResultItem.product}></mhecomm-k12-program-card-display>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-product-program-card-view': ProductProgramCardView;
  }
}